import { Col, Form, Row } from 'antd';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import ContentSpinner from '../../../../../../components/Spinners/ContentSpinner';
import AccessorialsDetails from '../../../common/Accessorials/AccessorialsDetails';

const AdditionalDetails = () => {
  const selectedAccessorialsRef = useRef({});
  const [form] = Form.useForm();
  const cargoSpecificAccessorials = useSelector((state) => state.shipment.cargoSpecificAccessorials);

  return (
    <Form
      name="additionalServicesForm"
      className="h-100 overflow-hidden "
      form={form}
      initialValues={{ accessorials: [] }}
    >
      <Row>
        <Col sm={8}>
          {cargoSpecificAccessorials?.progressing ? (
            <ContentSpinner />
          ) : (
            <AccessorialsDetails
              form={form}
              accessorials={cargoSpecificAccessorials?.data}
              selectedAccessorialsRef={selectedAccessorialsRef}
            />
          )}
        </Col>
      </Row>
    </Form>
  );
};

export default AdditionalDetails;
